import { ITireTreadManufacturer } from 'app/shared/model/tire-tread-manufacturer.model';
import { ICompany } from 'app/shared/model/company.model';

export interface ITireTreadModel {
  id?: number;
  name?: string | null;
  specification?: string | null;
  groove?: number | null;
  type?: string | null;    
  tireTreadManufacturer?: ITireTreadManufacturer | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<ITireTreadModel> = {};
